<template>
  <div style="position:relative">
    <div class="dashtag" :class="addClass" tabindex="0" @keypress.enter="$emit('clickBanner')">
      <div class="dashtag-left" :class="`is-${color}-dark`" @click="$emit('clickBanner')">
          <span class="is-size-3 middle circle-number"><span>{{title}}</span></span>
      </div>
      <div class="dashtag-right" :class="`is-${color}-dark`" style="position:relative" @click.self="$emit('clickBanner')">
        <p class="title has-text-white" @click.self="$emit('clickBanner')">{{ heading }}</p>
        <span v-if="config" @click.stop="showModal=true" class="config" tabindex="0" @keypress.enter.stop="showModal=!showModal">
          <icon selected="config" icoClass="event-ico"/>
        </span>
      </div>
    </div>
    <transition name="fade">
      <div :id="heading + 'modal'" v-if="showModal && config" class="config-modal" :class="`is-${color}`" v-click-outside="hide">
        <span class="fa fa-close close" @click="hide"></span>
        <slot name="modal"/>
        <div style="padding:10px 10px 0 0; text-align:right"><button style="height:2em;" class="button" @click="$emit('save'); showModal=false">Save</button></div>
      </div>
    </transition>
  </div>
</template>

<script>
import icon from './../svg/tabs'
export default {
  name: 'dashtag',
  props: ['color', 'addClass', 'title', 'heading', 'config'],
  components: {icon},
  data () {
    return {
      showModal: false
    }
  },
  methods: {
    hide () {
      if (this.showModal) {
        this.showModal = false
        this.$emit('tomas' + this.heading)
      }
    }
  },
  directives: {
    /* clickOutside: {
      bind (el, binding, vnode) {
        var event = function (event) {
          console.log(event.target)
          console.log(el)
          // eslint-disable-next-line
          if (!(el == event.target || el.contains(event.target))) {
            vnode.context[binding.expression](event)
          }
        }
        document.body.addEventListener('click', event)
      },
      unbind (el) {
        el.removeEventListener('click')
        document.body.removeEventListener('click', this.event)
      }
    }, */
    clickOutside: {
      bind: function (el, binding, vNode) {
        // Provided expression must evaluate to a function.
        if (typeof binding.value !== 'function') {
          const compName = vNode.context.name
          let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`
          if (compName) { warn += `Found in component '${compName}'` }
          console.warn(warn)
        }
        // Define Handler and cache it on the element
        const bubble = binding.modifiers.bubble
        const handler = (e) => {
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            binding.value(e)
          }
        }
        el.__vueClickOutside__ = handler
        // add Event Listeners
        document.addEventListener('click', handler)
      },
      unbind: function (el, binding) {
        // Remove Event Listeners
        document.removeEventListener('click', el.__vueClickOutside__)
        el.__vueClickOutside__ = null
      }
    }
  }
}
</script>

<style lang="scss">
$radius: 8px;
$padding: 12px;

.dashtag-wrapper{
  width: 25%;
  display: inline-block;
  padding: 0 15px;
}

.dashtag{
  outline: none;
  display: table;
  width: 100%;
  font-family: MuseoSans-900;
}

.dashtag-left{
  border-top-left-radius: $radius;
  border-bottom-left-radius: $radius;
  display: table-cell;
  vertical-align: middle;
  width: 30%;
  padding: $padding;
  text-align: center;
}

.dashtag-right{
  border-top-right-radius: $radius;
  border-bottom-right-radius: $radius;
  display: table-cell;
  vertical-align: middle;
  width: 70%;
  padding: $padding $padding $padding 0;
  .title{
    text-transform: uppercase;
    margin-bottom: 0;
    font-size: 1.5em;
  }
}
.config{
  padding: .3em;
  bottom:0;
  right:0;
  position: absolute;
  color: white;
  transition: .3s;
  font-size: 1em;
  &:hover{
    background: inherit;
    mix-blend-mode: screen;
    border-radius: $radius;
  }
}
.close{
  padding: .5em;
  top:0;
  right:0;
  position: absolute;
  color: white;
  transition: .3s;
  &:hover{
    background: inherit;
    mix-blend-mode: screen;
    border-radius: $radius;
  }
}
.config-modal{
  margin: .4em 0;
  position: absolute;
  display: inline-block;
  caption-side: bottom;
  border-radius: $radius;
  height: auto!important;
  width: 100%;
  min-width: 150px;
  box-sizing: border-box;
  z-index: 999;
  color: white;
  transition: all .3s ease;
  cursor: default;
  padding: 2em 1em 1em;
  font-size: 1.1em;
  font-weight: bold;
}
.fade-enter {
  opacity: 0;
}

.fade-leave-active {
  opacity: 0;
}

.fade-enter,
.fade-leave-active{
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
.circle-number {
  border-radius: 50%;
  color: #333333;
  background:white;
  width: 50px;
  height: 50px;
  display: table;
  span {
    display: table-cell;
    vertical-align: middle;
  }
}

</style>


// WEBPACK FOOTER //
// src/components/Dashtag.vue